import "../styles.css"
export const Adv=()=>{
    return (
        <div>
            <img className="adv-img" src="https://d2407na1z3fc0t.cloudfront.net/homepageStaticBanner/homepageStaticBanner_62a34b8cba7db" alt="adv" />
        </div>
        )
}